// Localized copy for the QuickTour flow + the "Take a tour" nav label. One
// JSON per non-English language; English is the source of truth in the
// tour's STEPS array so the fallback here is `null` (the caller keeps its
// hardcoded English string). Structural fields (route, target, pin, etc.)
// stay in code — only display strings come from these files.
import zh from '@/i18n/tour/zh.json';
import ko from '@/i18n/tour/ko.json';
import es from '@/i18n/tour/es.json';
import ar from '@/i18n/tour/ar.json';
import fa from '@/i18n/tour/fa.json';

const OVERLAYS = { zh, ko, es, ar, fa };

// Build a step-id → localized-fields lookup once per language, so the tour
// doesn't linearly scan the array on every render.
const _STEP_INDEX = {};
for (const [code, doc] of Object.entries(OVERLAYS)) {
  const byId = {};
  for (const step of (doc.steps || [])) {
    if (step && step.id) byId[step.id] = step;
  }
  _STEP_INDEX[code] = byId;
}

// Get the localized nav label ("Take a tour"). English falls back to the
// hardcoded string in AppShell.jsx.
export function tourNavLabel(lang, fallback) {
  const doc = OVERLAYS[lang];
  return (doc && doc.nav_label) || fallback;
}

// Return the localized version of a step. Missing fields fall back to the
// caller's English strings — matches the founder's "adapted, not literal"
// direction and means an incomplete translation never breaks the flow.
export function localizedStep(lang, step) {
  const overlay = _STEP_INDEX[lang]?.[step.id];
  if (!overlay) return step;
  return {
    ...step,
    eyebrow: overlay.eyebrow ?? step.eyebrow,
    title: overlay.title ?? step.title,
    body: overlay.body ?? step.body,
    cta: overlay.cta ?? step.cta,
    secondary: overlay.secondary ?? step.secondary,
  };
}
